import type { IconProps } from '../types/IconProps.ts';
export const Images: IconProps = {
    name: 'Images',
    children: [
        `<rect width="14" height="14" x="8" y="2" rx="2" />`,
        `<path d="m11 16 4.98-4.87a2 2 0 0 1 1.8-.53l4.22.84" />`,
        `<circle cx="13" cy="7" r="1" />`,
        `<path d="M3.47 8C2.66 8 2 8.66 2 9.47V20c0 1.1.9 2 2 2h10.44c.86 0 1.56-.7 1.56-1.56" />`,
    ]
};